import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import remarkBreaks from "remark-breaks";
import { cn } from "@/lib/utils";

interface MarkdownMessageProps {
  content: string;
  className?: string;
}

export const MarkdownMessage: React.FC<MarkdownMessageProps> = ({ content, className }) => {
  return (
    <div
      className={cn(
        "prose prose-neutral dark:prose-invert prose-sm max-w-none",
        "prose-headings:mt-0 prose-p:leading-relaxed prose-li:leading-relaxed",
        "prose-pre:bg-muted prose-pre:border prose-pre:border-border prose-pre:rounded-md",
        "prose-code:before:content-[''] prose-code:after:content-['']",
        className
      )}
    >
      <ReactMarkdown
        remarkPlugins={[remarkGfm, remarkBreaks]}
        components={{
          a: ({ node, ...props }) => (
            <a {...props} target="_blank" rel="noopener noreferrer" />
          ),
          pre: ({ node, ...props }) => (
            <pre {...props} className={cn("overflow-x-auto", (props as any).className)} />
          ),
          code: (props: any) => {
            const { inline, className, children, ...rest } = props || {};
            return (
              <code
                className={cn(!inline && "block", className)}
                {...rest}
              >
                {children}
              </code>
            );
          },
          img: ({ node, ...props }) => (
            // Ensure images are responsive and have alt text for accessibility/SEO
            <img {...props} loading="lazy" alt={(props.alt as string) || "conteúdo da resposta da IA"} />
          ),
        }}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
};

export default MarkdownMessage;
